import tech from "../images/tech.jpg";
import art from "../images/art.jpg";
import music from "../images/music.jpg";
import startup from "../images/startup.jpg";
import food from "../images/food.jpg";
import gaming from "../images/gaming.jpg";
import indie from "../images/indie.jpg";
import hackathon from "../images/hackathon.jpg";
import streetfood from "../images/streetfood.jpg";
import digital from "../images/digital.jpg";
import league from "../images/league.jpg";
const events = [
  {
    id: 1,
    title: "Tech Fest 2026",
    date: "2026-05-10",
    location: "Madurai",
    description: "Latest tech workshops",
    seats: 120,
    price: 500,
    image: tech
  },
  {
    id: 2,
    title: "Music Night",
    date: "2026-06-20",
    location: "Chennai",
    description: "Live concert experience",
    seats:120,
    price: 800,
    image: music
  },
  {
    id: 3,
    title: "Startup Meetup",
    date: "2026-07-15",
    location: "Bangalore",
    description: "Networking for entrepreneurs",
    seats:120,
    price:300,
    image: startup
  },
  {
    id: 4,
    title: "Art Exhibition",
    date: "2026-08-05",
    location: "Delhi",
    description: "Modern art showcase",
    seats:120,
    price:200,
    image: art
  },
  {
    id: 5,
    title: "Food Festival",
    date: "2026-09-10",
    location: "Hyderabad",
    description: "Taste cuisines from around the world",
    seats:120,
    price:400,
    image:food
  },
  {
    id: 6,
    title: "Gaming Tournament",
    date: "2026-10-12",
    location: "Mumbai",
    description: "Esports competition",
    seats:120,
    price:600,
    image: gaming
  },
  {
    id: 8,
    title: "Indie Music Festival",
    date: "2026-11-25",
    location: "Goa",
    description: "Independent artists live performances",
    seats:120,
    price:"1000/-",
    image: indie
  },
  {
    id: 9,
    title: "Hackathon 48 Hours",
    date: "2026-12-10",
    location: "Bangalore",
    description: "Non-stop coding challenge with prizes",
    seats:120,
    price:"760/-",
    image: hackathon
  },
  {
    id: 10,
    title: "Street Food Carnival",
    date: "2027-01-08",
    location: "Chennai",
    description: "Best street foods in one place",
    seats:120,
    price:"500/-",
    image: streetfood
  },
  {
    id: 11,
    title: "Startup Pitch Day",
    date: "2027-02-14",
    location: "Mumbai",
    description: "Pitch your ideas to top investors",
    seats:120,
    price:"899/-",
    image: startup
  },
  {
    id: 12,
    title: "Digital Art Workshop",
    date: "2027-03-03",
    location: "Delhi",
    description: "Learn digital painting from experts",
    seats:120,
    price:"853/-",
    image: digital
  },
  {
    id: 13,
    title: "Pro Gaming League Finals",
    date: "2027-03-25",
    location: "Hyderabad",
    description: "Final showdown of top esports teams",
    seats:120,
    price:"299/-",
    image: league
  }
];
export default events;